import React from 'react';
import { Container, Flex, Heading, Text } from '@chakra-ui/react';
import MemberHeroSection from '@/components/membership/MemberHeroSection';

const linksData = [
  {
    id: 'SEBI_RELAXATION_CIRCULAR',
    date: '14th February 2025',
    text: 'SEBI Circular on Relaxation in timelines for holding AIFs’ investments in dematerialised form',
    link: 'https://static.levocdn.com/WGLBUT82/RelaxationintimelineforreportingofdifferentialrightsissuedbyAIFs2-ImvZBQVT4IHY.pdf',
  },
  {
    id: 'SEBI_DEMATTING_IMPLEMENTATION_STANDARDS',
    date: '25th January 2024',
    text: 'Implementation Standards for credit of AIF units in Demat',
    link: 'https://static.levocdn.com/WGLBUT82/ImplementationStandardsformulatedbythepilotSFAforSEBIcircularonCreditofunitsofAIFsindematerialisedform-6HgbxPw1NerX.pdf',
  },
  {
    id: 'SEBI_DEMATTING_PRESS_RELEASE',
    date: '25th January 2024',
    text: 'Press Release by IVCA on Dematting Circular Compliance',
    link: 'https://static.levocdn.com/WGLBUT82/Press%20Release_Important%20Notice%20to%20AIF%20Managers-7156293706179049814.pdf',
  },
  {
    id: 'SEBI_DEMATTING_CIRCULAR_COMPLIANCE',
    date: '25th January 2024',
    text: 'Email sent to IVCA Members on Dematting Circular Compliance',
    link: 'https://static.levocdn.com/WGLBUT82/Important%20Notice%20to%20AIF%20Managers-%20Compliance%20with%20Circular%20Regarding%20Credit%20to%20Demat%20&%20Aggregate%20Escrow%20Demat%20%20Accounts-7156293706182540516.pdf',
  },
  {
    id: 'SEBI_DEMATTING_CIRCULAR_COMPLIANCE',
    date: '12th January 2024',
    text: 'SEBI Circular on Guidelines for AIFs with respect to holding their investments in dematerialised form and appointment of custodian',
    link: 'https://static.levocdn.com/WGLBUT82/GuidelinesforAIFswithrespecttoholdingtheirinvestmentsindematerialisedformandappointmentofcustodian-QsAk4OXkulUX.pdf',
  },
  {
    id: 'CDSL_Procedure',
    date: 'December 2023',
    text: 'CDSL Procedure',
    link: 'https://static.levocdn.com/WGLBUT82/7145751653605706790.pdf',
  },
  {
    id: 'CDSL_FAQS',
    date: 'December 2023',
    text: 'CDSL FAQs',
    link: 'https://static.levocdn.com/WGLBUT82/7145751653605573411.pdf',
  },
  {
    id: 'NSDL_CIRCULAR',
    date: 'December 2023',
    text: 'NSDL Circular on Addition of New Client',
    link: 'https://static.levocdn.com/WGLBUT82/7145751653602530937.pdf',
  },
  {
    id: 'NSDL_FAQ',
    date: 'December 2023',
    text: 'NSDL FAQ on Conversion of AIF',
    link: 'https://static.levocdn.com/WGLBUT82/7145751653580274783.pdf',
  },
  {
    id: 'SEBI_DEMATTING1',
    date: '-',
    text: 'FAQs on SEBI Dematting by CDSL',
    link: 'https://www.cdslindia.com/Footer/AIF.aspx',
  },
  {
    id: 'SEBI_DEMATTING2',
    date: '-',
    text: 'FAQs on SEBI Dematting by NSDL',
    link: 'https://nsdl.co.in/downloadables/pdf/FAQ-Conversion-of-Physical-unitsof-IF-into-Demat.pdf',
  },
  {
    id: 'SEBI_Circular',
    date: '11th December 2023',
    text: 'SEBI Circular on Credit of units of AIFs in dematerialised form',
    link: 'https://static.levocdn.com/WGLBUT82/CreditofunitsofAIFsindematerialisedform-eg6dlkTj3dM1.pdf',
  },
  {
    id: 'SEBI_Circular',
    date: '21st June 2023',
    text: '21st June 2023: SEBI Circular on Issuance of units of AIFs in dematerialised form',
    link: 'https://static.levocdn.com/WGLBUT82/7145751653604273210.pdf',
  },
];

const DemattingofAifUnits = () => (
  <Flex direction="column" rowGap="20px">
    <MemberHeroSection
      title={
        <Heading
          as="h1"
          variant="headingText"
          color="text.headingWhite"
          fontSize={{ xs: '36px', sm: '60px', md: '74px' }}
          textAlign={{ xs: 'left', sm: 'left' }}
        >
          Dematerialisation of Units and Investments of AIFs
        </Heading>
      }
      type="about-us"
    />
    <Container
      maxW="container.xl"
      pt={{ xs: '50px', md: '50px' }}
      pb={{ xs: '50px', md: '50px' }}
      as="section"
      id="info"
      scrollMarginTop="140px"
    >
      <Flex direction="column" gap="2">
        {linksData.map((item) => (
          <Flex
            key={item.id}
            direction={{ base: 'column', md: 'row' }}
            cursor="pointer"
            gap={{ md: '5' }}
            onClick={() => {
              window.open(item?.link, '_blank');
            }}
          >
            <Flex minWidth="200px">
              {item?.date ? (
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item?.date}
                </Text>
              ) : (
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item?.text}
                </Text>
              )}
              {item.date && (
                <Text
                  display={{ base: 'block', md: 'none' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
              )}
            </Flex>
            {item.date && (
              <Flex>
                <Text
                  display={{ base: 'none', md: 'block' }}
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  :&nbsp;
                </Text>
                <Text
                  cursor="pointer"
                  //   variant="infoText"
                  variant="heroDesc"
                  color="text.mediumBlackAlpha"
                  _hover={{
                    textDecoration: 'underline',
                  }}
                >
                  {item.text}
                </Text>
              </Flex>
            )}
          </Flex>
        ))}
      </Flex>
    </Container>
  </Flex>
);

export default DemattingofAifUnits;
